import { headerClsPrefix } from "../../../../../constants";
import { getLabel } from "@weapp/utils";
import wechatImg from "../../../../../assets/eteams_wechat.jpg";
import React from "react";

export function WxchatCom(props: any) {
  return <div className={`${props?.className} ${headerClsPrefix}-dropmenu-item-originPopover`}>
    <h3>{getLabel('13765', '微信号')}</h3>
    <p>{getLabel('62186', '扫描二维码关注我们')}</p>
    <img src={wechatImg} alt="" />
  </div>
}